
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import EisenhowerQuadrantColumn from './EisenhowerQuadrantColumn';
import { Task } from '@/context/TaskContext';

interface Quadrant {
  id: string;
  label: string;
  icon: string;
}
interface EisenhowerQuadrantGridProps {
  quadrants: Quadrant[];
  quadrantTasks: { [key: string]: Task[] };
}

const EisenhowerQuadrantGrid: React.FC<EisenhowerQuadrantGridProps> = ({
  quadrants, quadrantTasks,
}) => (
  <div className="grid grid-cols-2 grid-rows-2 gap-5 h-full">
    {quadrants.map((quadrant, idx) => (
      <Droppable
        key={quadrant.id}
        droppableId={`quadrant-${quadrant.id}`}
        direction="vertical"
      >
        {(provided) => (
          <EisenhowerQuadrantColumn
            id={quadrant.id}
            label={quadrant.label}
            icon={quadrant.icon}
            tasks={quadrantTasks[quadrant.id]}
            provided={provided}
            innerRef={provided.innerRef}
            handleDragStart={() => {}}
          />
        )}
      </Droppable>
    ))}
  </div>
);

export default EisenhowerQuadrantGrid;
